import { useMemo } from 'react';

import { getStatusUpdateSignalMatch } from '@confluence/status-update-signal/entry-points/getStatusUpdateSignalMatch.ts';
import type {
	StatusUpdateChild,
	StatusUpdateSignalMatch,
} from '@confluence/status-update-signal/entry-points/getStatusUpdateSignalMatch.ts';
import { resolveStatusUpdateCadence } from '@confluence/status-update-signal/entry-points/resolveStatusUpdateCadence.ts';
import type { StatusUpdateCadence } from '@confluence/status-update-signal/entry-points/detectStatusUpdateCadence.ts';

interface UseMatchesStatusUpdateInput {
	title?: string | null;
	parentTitle?: string | null;
	sourceTemplateEntityId?: string | null;
	children?: readonly StatusUpdateChild[];
}

export type StatusUpdateSignal = StatusUpdateSignalMatch & {
	/**
	 * Cadence inferred from the page title, its children series or the parent
	 * title. Defaults to weekly.
	 */
	cadence: StatusUpdateCadence;
};

export const useMatchesStatusUpdate = ({
	title,
	parentTitle,
	sourceTemplateEntityId,
	children,
}: UseMatchesStatusUpdateInput): StatusUpdateSignal => {
	return useMemo(() => {
		const input = {
			title: title ?? undefined,
			parentTitle: parentTitle ?? null,
			templateId: sourceTemplateEntityId ?? null,
			children,
		};

		return {
			...getStatusUpdateSignalMatch(input),
			cadence: resolveStatusUpdateCadence(input),
		};
	}, [title, parentTitle, sourceTemplateEntityId, children]);
};
